"use client";

import type { FaqSection as FaqSectionType } from "./faqTypes";
import { FaqAccordion, type FaqAccordionItem } from "./FaqAccordion";

export interface FaqSectionProps {
  section: FaqSectionType;
  itemIdPrefix: string;
}

/**
 * Renders one FAQ section with an anchored heading and accordion list.
 */
export function FaqSection({ section, itemIdPrefix }: FaqSectionProps) {
  const items: FaqAccordionItem[] = section.items.map((item, index) => ({
    id: `${itemIdPrefix}-${section.id}-${index + 1}`,
    question: item.question,
    answer: item.answer,
  }));

  return (
    <section
      id={section.id}
      className="gruv-faq__section"
      aria-labelledby={`${section.id}-title`}
      data-testid={`faq-section-${section.id}`}
    >
      <h2 id={`${section.id}-title`} className="gruv-faq__section-title">
        {section.title}
      </h2>
      <FaqAccordion items={items} />
    </section>
  );
}
